import {Form} from 'vform';
import moment from "moment-timezone";
import axios from "axios";

export default {
  async canCurrentUserImpersonate(targetUserID) { // MLD-7488
    try {
      const {data} = await axios.get(`/api/users/${targetUserID}/can-be-impersonated-by-current-user`);
      return data.can_impersonate;
    } catch (e) {
      return false;
    }
  },
  addUserToTeam(userID, teamID, roleID) {
    return axios.post(`/api/users/${userID}/teams/${teamID}`, {role: roleID})
      .then(response => {
        return response.data;
      })
  },
  changeTeamRole(userID, teamID, roleID) {
    return axios.put(`/api/users/${userID}/teams/${teamID}/role`, {role: roleID})
      .then(response => {
        return response.data;
      })
  },
  removeUserFromTeam(userID, teamID) {
    return axios.delete(`/api/users/${userID}/teams/${teamID}`)
      .then(response => {
        return response.data;
      })
  },
  switchUserToTeam(userID, teamID) {
    return axios.post(`/api/users/${userID}/teams/${teamID}/switch`);
  },
  initForm() {
    return new Form({
      first_name: null,
      last_name: null,
      suffix: null, // MLD-4293
      status: 'Active',
      email: null,
      phone: null,
      phone_extension: null, // MLD-2842
      sms_notifications_enabled: false, // MLD-2155
      country: 'US',
      timezone: 'America/New_York',
      password: null,
      groups: [],
      send_email: false,
      role: 'Team Member',
      expires_at: null,
      signature: null,
      title: null,
      scanner_enabled: true, // MLD-971, MLD-1268
      calendar_url: null, // MLD-1154
      locale: 'en', // MLD-1323
      external_id: null, // MLD-1374
      division: null, // MLD-3199
      department: null, // MLD-3199
      region: null, // MLD-1628
      district: null, // MLD-1628
      territory: null, // MLD-1628
      crm_mailbox: null, // MLD-1900
      sso_username: null, // MLD-2070
      manager_id: '', // MLD-2197
      can_use_builder: true, // MLD-2882
      // MLD-2635
      send_recommendations: false,
      send_unsubscribe_notifications: true, // MLD-4309
      send_failed_email_notifications: true, // MLD-3699
      send_permanently_failed_email_notifications: true, // MLD-4312
      send_presentation_imported_notifications: true, // MLD-7797
      send_upload_notifications: false,
      send_delete_notifications: false,
      send_expiration_notifications: false,
      photo_url: null, // MLD-2720
      // MLD-2986
      billing_address: null,
      billing_address_line_2: null,
      billing_city: null,
      billing_state: '',
      billing_zip: null,
      billing_country: null,
      // MLD_7203
      pipedrive_api_token: null,
      default_greeting_type: 'Formal', // MLD-8195
    })
  },
  initFormForUser(form, user) {
    form.first_name = user.first_name;
    form.last_name = user.last_name;
    form.suffix = user.suffix; // MLD-4293
    form.status = user.status;
    form.email = user.email;
    form.timezone = user.timezone;
    form.country = user.country.id;
    form.phone = user.phone;
    form.phone_extension = user.phone_extension; // MLD-2842
    form.sms_notifications_enabled = user.sms_notifications_enabled; // MLD-2155
    form.groups = user.groups.map(g => g.id);
    form.role = user.team.role;
    form.expires_at = (user.expires_at) ? moment.utc(user.expires_at).tz(this.timezone).format('YYYY-MM-DDTHH:mm') : null;
    form.signature = user.signature;
    form.title = user.title; // MLD-910
    form.scanner_enabled = user.scanner_enabled; // MLD-971
    form.calendar_url = user.calendar_url; // MLD-1154
    form.locale = user.locale; // MLD-1323
    form.external_id = user.external_id; // MLD-1374
    form.division = user.division; // MLD-3199
    form.department = user.department; // MLD-3199
    form.region = user.region; // MLD-1628
    form.district = user.district; // MLD-1628
    form.territory = user.territory; // MLD-1628
    form.crm_mailbox = user.crm_mailbox; // MLD-1900
    form.sso_username = user.sso_username; // MLD-2070
    form.manager_id = user.manager_id ? user.manager_id : ''; // MLD-2197
    form.can_use_builder = user.can_use_builder;
    // MLD-2635
    form.send_recommendations = user.send_recommendations;
    form.send_upload_notifications = user.send_upload_notifications;
    form.send_delete_notifications = user.send_delete_notifications;
    form.send_expiration_notifications = user.send_expiration_notifications;
    form.send_failed_email_notifications = user.send_failed_email_notifications; // MLD-4168
    form.send_permanently_failed_email_notifications = user.send_permanently_failed_email_notifications; // MLD-4312
    form.send_presentation_imported_notifications = user.send_presentation_imported_notifications; // MLD-7797
    form.send_unsubscribe_notifications = user.send_unsubscribe_notifications; // MLD-4309
    form.photo_url = user.photo_url; // MLD-2720
    // MLD-2968
    form.billing_address = user.billing_address;
    form.billing_address_line_2 = user.billing_address_line_2;
    form.billing_city = user.billing_city;
    form.billing_state = user.billing_state;
    form.billing_zip = user.billing_zip;
    form.billing_country = user.billing_country;
    form.default_greeting_type = user.default_greeting_type; // MLD-8195
    return form;
  },
  async uploadPhoto(userID, photo) { // MLD-7821
    const formData = new FormData();
    formData.append('photo', photo);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    const {data} = await axios.post(`/api/users/${userID}/photo`, formData, config);
    return data;
  },
  async deletePhoto(userID) { // MLD-7821
    await axios.delete(`/api/users/${userID}/photo`);
  },
  async updateUser(form, userID) { // MLD-7821
    const {data} = await form.put(`/api/users/${userID}`);
    return data;
  },
}
